import { RouteRecordRaw } from 'vue-router'

const UserManagerRouter: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "userManager" */'@/views/user/login.vue')
  },
  {
    path: '/forgotPassword',
    name: '忘记密码',
    meta: {
      title_en: 'forgotPassword',
      title: '忘记密码'
    },
    component: () => import(/* webpackChunkName: "userManager" */'@/views/user/forgotPassword.vue')
  },
]
export default UserManagerRouter
